export default __webpack_public_path__ + "static/media/vim.84ecac00.webp";